import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { LaboratorioService } from 'src/app/services/laboratorio/laboratorio.service';

@Component({
  selector: 'app-informacion-pruebas',
  templateUrl: './informacion-pruebas.component.html',
  styleUrls: ['./informacion-pruebas.component.scss'],
  standalone: false
})
export class InformacionPruebasComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized = false;

  public pruebas: any[] = [];
  public cargando = false;
  public guardando = false;

  public formNueva: any = this.defaultForm();
  public formEditar: any = this.defaultForm();
  public idPruebaEditar = 0;

  constructor(
    private laboratorioService: LaboratorioService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[0, 'asc']],
      language: LanguageApp.spanish_datatables
    };

    this.obtenerPruebas();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  get token(): string {
    return localStorage.getItem('token') || '';
  }

  defaultForm() {
    return {
      nombre: '',
      muestra: '',
      contenedor: '',
      condicion: '',
      resultadoNumero: '',
      resultadoTiempo: 'DIAS',
      tipoResultado: '',
      especificaciones: ''
    };
  }

  obtenerPruebas() {
    this.cargando = true;
    this.laboratorioService.listarInformacionPruebas(this.token).subscribe({
      next: (resp: any) => {
      this.pruebas = Array.isArray(resp?.rows) ? resp.rows : [];
      if (!this.isDtInitialized) {
        this.dtTrigger.next(null);
        this.isDtInitialized = true;
      } else {
        this.rerender();
      }
      this.cargando = false;
      },
      error: () => {
        this.pruebas = [];
        this.cargando = false;
      }
    });
  }

  private rerender(): void {
    if (!this.dtElement) return;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  abrirAgregar(modal: any) {
    this.formNueva = this.defaultForm();
    this.modalService.open(modal, { centered: true, size: 'lg' });
  }

  abrirEditar(modal: any, item: any) {
    this.idPruebaEditar = Number(item.CODINF_LAB);

    const resultadoRaw = String(item.RESINF_LAB || '');
    const [resultadoNumero, ...resto] = resultadoRaw.split(' ');
    const resultadoTiempo = (resto.join(' ') || 'DIAS').toUpperCase();

    this.formEditar = {
      nombre: String(item.NOMINF_LAB || ''),
      muestra: String(item.MUEINF_LAB || ''),
      contenedor: String(item.CONINF_LAB || ''),
      condicion: String(item.CONDINF_LAB || ''),
      resultadoNumero: resultadoNumero || '',
      resultadoTiempo: ['DIAS', 'HORAS', 'MINUTOS'].includes(resultadoTiempo) ? resultadoTiempo : 'DIAS',
      tipoResultado: String(item.TIPMUES_INF || ''),
      especificaciones: String(item.ESPMUES_INF || '')
    };

    this.modalService.open(modal, { centered: true, size: 'lg' });
  }

  guardarPrueba() {
    this.guardando = true;
    this.laboratorioService.crearInformacionPrueba(this.token, this.formNueva).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Prueba creada correctamente');
        this.modalService.dismissAll();
        this.obtenerPruebas();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo crear la prueba');
      }
    });
  }

  editarPrueba() {
    if (!this.idPruebaEditar) return;

    this.guardando = true;
    this.laboratorioService.editarInformacionPrueba(this.token, this.idPruebaEditar, this.formEditar).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Prueba editada correctamente');
        this.modalService.dismissAll();
        this.obtenerPruebas();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo editar la prueba');
      }
    });
  }

  eliminarPrueba(item: any) {
    const idPrueba = Number(item.CODINF_LAB);
    if (!idPrueba) return;

    Swal.fire({
      title: '¿Eliminar prueba?',
      text: 'Esta acción no se puede revertir.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.laboratorioService.eliminarInformacionPrueba(this.token, idPrueba).subscribe({
        next: () => {
          this.toastr.success('Prueba eliminada correctamente');
          this.obtenerPruebas();
        },
        error: () => {
          this.toastr.error('No se pudo eliminar la prueba');
        }
      });
    });
  }
}

export class LanguageApp {
  public static spanish_datatables = {
    processing: 'Procesando...',
    search: 'Buscar:',
    lengthMenu: 'Mostrar _MENU_ registros',
    info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
    infoEmpty: 'Mostrando ningún elemento.',
    infoFiltered: '(filtrado _MAX_ elementos total)',
    infoPostFix: '',
    loadingRecords: 'Cargando registros...',
    zeroRecords: 'No se encontraron registros',
    emptyTable: 'No hay datos disponibles en la tabla',
    paginate: { first: 'Primero', previous: 'Ant', next: 'Sig', last: 'Último' },
    aria: {
      sortAscending: ': Activar para ordenar la tabla en orden ascendente',
      sortDescending: ': Activar para ordenar la tabla en orden descendente'
    }
  };
}
